import { render } from "./IconRadio.vue?vue&type=template&id=1251940e"
import script from "./IconRadio.vue?vue&type=script&lang=ts"
export * from "./IconRadio.vue?vue&type=script&lang=ts"
script.render = render

export default script